<template>
	<v-card class="opaqueBg02" rounded elevation="10" style="height: 100%">
		<v-overlay :value="!title" absolute>
			Open collection to view files
		</v-overlay>
		<v-card-text>
			<div class="mb-4 d-flex" style="">
				<span class="text-h4" v-text="currentCollectionTitle" id="fileTitle" />
				<v-spacer />
				<!-- <EditButton v-if="title" @click="$emit('edit-collection', title)" /> -->
				<v-btn tile solid v-if="title && adminMode" color="success" class="mr-4"  @click="newCollection">
					<v-icon left>mdi-folder-plus</v-icon> Add Collection
				</v-btn>
				<DeleteButton solid v-if="title && adminMode" @doDelete="$emit('remove-collection', currentCollectionTitle)" :folderTitle="currentCollectionTitle"/>
			</div>

			<v-card rounded class="opaqueBg">
				<CollectionList v-if='currentCollectionTitle' name='nestedList' :title="collection" :collections="calculatedCollection" @show="showCollection" />
				<Collection
					:collection="files"
					:currentTitle="currentCollectionTitle"
					:form="$options.FileForm"
					:disableNew='!adminMode'
					@change="dataChanged = true"
					@newFileAdded="newFileAdded"
					dialogWidth="600"
					title="File"
					breakpoints="xs12"
					max-width="100%"
					itemMargin="ma-0"
					hideHelp
					isFileUpload
					:uploadFn="uploadFn"
					v-if="currentCollectionTitle"
				>
				
					<CollectionFile
						@remove="confirmFileDelete(item)"
						@view-file="openFile(item)"
						slot-scope="{ item }"
						v-bind="item"
						:showDelete="adminMode"
					/>
				</Collection>
			</v-card>
		</v-card-text>
	</v-card>
</template>

<script>
import Collection from '@/components/admin/FileItemCollection'
import CollectionFile from './n-items/CollectionFile'
import CollectionList from './CollectionList.vue'
import DeleteButton from '@/components/ui/DeleteButton'
import EditButton from '@/components/ui/EditButton'
import Messages from '@/helpers/message-helper'
import FileCollectionForm from '@/components/dialogs/forms/FileCollectionForm'
import FileForm from '@/components/dialogs/forms/FileFormBasic'
import Dialog from '@/components/dialogs/DialogEdit'
import FileService from '@/services/FileServiceProtected'

export default {
	name: 'CollectionFiles',
	FileForm,
	components: {
		Collection,
		CollectionFile,
		DeleteButton,
		EditButton,
		CollectionList
	},
	props: {
		title: String,
		collectionTitle: String,
		uploadFn: [Function, Object],
		files: Array,
		adminMode: Boolean,
		collections: Array,
		collection: String,
	},
	data() {
		return {
			calculatedCollection: [],
			currentCollectionTitle: '',
			
			
		}
		
	},
	methods: {
		setActiveFolderName(currentCollectionTitle) {
			this.calculatedCollection = []
			this.currentCollectionTitle = currentCollectionTitle
			for(const col in this.collections){
				let count = 0
				const currentMatchBegining = this.collections[col].match(currentCollectionTitle+'/')
				if(currentMatchBegining) {
					let partToCheck = this.collections[col].replace(currentMatchBegining, '')
					count = partToCheck.split("/").length-1	
					
					if( count === 0 ){
						this.calculatedCollection.push(this.collections[col]) 
					} 
				}
			}
		},
		newFileAdded(currentFolderTitle){
			this.showCollection(currentFolderTitle)
		},
		openFile(file) {
			window.open(file.path)
		},
		removeCollectionDisplay(collection) {
			const index = this.calculatedCollection.findIndex((e) => e == collection)
			index !== -1 ? this.calculatedCollection.splice(index, 1) : ''
		},
		removeFile(file) {
			this.$emit('remove-file', file.key, this.currentCollectionTitle)
		},
		newCollection() {
			this.showDialog()
		},
		calculateTitle(title){
			const folderPrefix = this.currentCollectionTitle;
			const titleLink = folderPrefix + '/'+ title

			return titleLink
		},
		async showCollection(collection) {
			this.$emit('show', collection)
		},
		async confirmFileDelete(file) {
			this.$swal({
						title: 'Are you sure that you want to delete ' + file.title + '?' ,
						icon: 'warning',
						confirmButtonColor: '#11d472',
						cancelButtonColor: '#FF0000',
						showCancelButton: true,
						cancelButtonText: 'No',
						confirmButtonText: 'Yes'
						}).then((result) =>  {
							if(result.isConfirmed){
								this.removeFile(file)
							}							
						})
		},
		async showDialog() {
			
			const result = await this.$dialog.showAndWait(Dialog, {
				title: 'Add New File Collection',
				component: FileCollectionForm,
				data: {},
				icon: false,
				width: 600,
				hideDelete: true
			})

			// If action is not save, the dialog was cancelled
			if (!result || result.action != 'save') return
			const {
				dialogData: { title }
			} = result

			try {
				const link = this.calculateTitle(title)
				Messages.showSaving()

				await FileService.createCollection(link)
				this.calculatedCollection.push(link)
				
				Messages.showSuccess('inserted')
			} catch (error) {
				Messages.showError(error)
			}
		}
	}
}
</script>